import React from 'react';
import { Bike } from 'lucide-react';
export function Footer() {
  return <footer className="py-16 px-4 bg-slate-950 text-center border-t border-slate-800" role="contentinfo" data-id="element-115">
      <div className="max-w-3xl mx-auto" data-id="element-116">
        <p className="text-slate-400 mb-8" data-id="element-117">
          El próximo sábado puede ser diferente.
        </p>

        <h2 className="text-2xl md:text-3xl font-serif font-bold text-white italic mb-12" data-id="element-118">
          🚴 "Desde hoy, tu entrenamiento tiene sistema."
        </h2>

        <div className="space-y-6 max-w-md mx-auto mb-16" data-id="element-119">
          <a href="https://fegion.shop/cart/46201145950347:1" target="_blank" rel="noopener noreferrer" className="block w-full bg-slate-900 border border-slate-700 hover:border-amber-500 rounded-xl p-4 transition-colors" data-id="element-120">
            <p className="text-blue-400 font-bold mb-1" data-id="element-121">
              📘 PACK BASE — PROTORRENDA 4-12
            </p>
            <p className="text-slate-400 text-sm mb-2" data-id="element-122">
              <span className="line-through" data-id="element-123">$49.990</span> →{' '}
              <span className="text-white font-bold" data-id="element-124">$19.990 ARS</span>
            </p>
            <p className="text-amber-500 font-bold text-sm" data-id="element-125">
              🚴 Quiero mi Sistema PROTORRENDA
            </p>
          </a>

          <a href="https://fegion.shop/cart/46201151553675:1" target="_blank" rel="noopener noreferrer" className="block w-full bg-green-600 hover:bg-green-500 rounded-xl p-4 transition-colors shadow-lg" data-id="element-126">
            <p className="text-white font-bold mb-1" data-id="element-127">
              🏆 COMBO PRO — PROTORRENDA 4-12 + PELOTÓN 10X ⭐
            </p>
            <p className="text-green-200 text-sm mb-2" data-id="element-128">
              <span className="line-through opacity-70" data-id="element-129">$69.990</span> →{' '}
              <span className="text-white font-bold" data-id="element-130">$29.990 ARS</span>
            </p>
            <p className="text-white font-bold text-sm" data-id="element-131">
              → Quiero el Pack Completo con Pelotón 10X
            </p>
          </a>
        </div>

        <div className="flex flex-wrap justify-center gap-4 text-xs text-slate-500 mb-12" data-id="element-132">
          <span data-id="element-133">🔒 Pago 100% seguro</span>
          <span data-id="element-134">⚡ Acceso en 5 minutos</span>
          <span data-id="element-135">🛡️ Garantía 7 días</span>
          <span data-id="element-136">💳 Mercado Pago · Tarjeta · Transferencia</span>
        </div>

        <Bike className="w-8 h-8 text-amber-500 mx-auto mb-6" strokeWidth={2} aria-hidden="true" data-id="element-137" />
        <p className="text-white font-bold text-lg mb-2" data-id="element-138">PROTORRENDA 4-12</p>
        <p className="text-slate-400 text-sm mb-2" data-id="element-139">
          El método N°1 de entrenamiento para ciclistas amateurs argentinos.
        </p>

        <div className="flex justify-center gap-6 text-slate-500 text-sm mb-8" data-id="element-140">
          <a href="#" className="hover:text-amber-500 transition-colors" data-id="element-141">
            📧 soporteoficialfegion@gmail.com
          </a>
          <a href="#" className="hover:text-amber-500 transition-colors" data-id="element-142">
            📲 @fegion.protorrenda
          </a>
          <a href="#" className="hover:text-amber-500 transition-colors" data-id="element-143">
            🌐 tu-web
          </a>
        </div>

        <p className="text-slate-600 text-xs" data-id="element-144">
          © PROTORRENDA 4-12™ 2026 — Todos los derechos reservados. Prohibida
          la reproducción y redistribución sin autorización expresa.
        </p>
      </div>
    </footer>;
}